import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { MenuItemStyled, StyledText } from './styled/MenuStyled';

function MenuItem({ onTap, name, value, isCurrent, isBlocked }) {
  return (
    <MenuItemStyled
      onClick={onTap}
      hasValue={Boolean(value)}
      isBlocked={isBlocked}
    >
      <StyledText
        wight="600"
        size="fs_s"
        color={isCurrent ? 'green_turquoise' : 'black'}
        fixedSize
      >
        {name}
      </StyledText>
      {value && (
        <StyledText
          color={isCurrent ? 'green_turquoise' : 'gray_darkgray'}
          size="fs_xxs"
          weight="100"
          fixedSize
        >
          {value}
        </StyledText>
      )}
    </MenuItemStyled>
  );
}

MenuItem.propTypes = {
  onTap: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  isCurrent: PropTypes.bool,
  isBlocked: PropTypes.bool,
};

MenuItem.defaultProps = {
  isCurrent: false,
  isBlocked: false,
};

export default memo(MenuItem);
